<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc full-character-formatting" id="table-of-contents">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">CONTENTS</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/forthcoming"><span class="item-title-text">forthcoming</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/introduction"><span class="item-title-text">Introduction</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">1. </span><a href="#/chapter001"><span class="item-title-text">A Man of His Words</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">2. </span><a href="#/chapter002"><span class="item-title-text">A Night in Zion</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/apersonalinterlude"><span class="item-title-text">A Personal Interlude</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">3. </span><a href="#/chapter003"><span class="item-title-text">Time and Motion</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">4. </span><a href="#/chapter004"><span class="item-title-text">Rebirth, Renaissance, and The End</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/conclusion" title="Link target outside of Sample"><span class="item-title-text">Conclusion</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/bibliography" title="Link target outside of Sample"><span class="item-title-text">Bibliography</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/appendixa"><span class="item-title-text">Appendix A</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/appendixb"><span class="item-title-text">Appendix B</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/appendixc"><span class="item-title-text">Appendix C</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/acknowledgments" title="Link target outside of Sample"><span class="item-title-text">Acknowledgments</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/abouttheauthor"><span class="item-title-text">About the Author</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/ifyouliked"><span class="item-title-text">If You Liked …</span></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?76117bd7